export const objectTransformer = (obj, type) => {
    switch (type) {
        case 'GET': {
            const responseData = obj?.data;
            const subscriptions = responseData?.subscriptions?.globalGSK;
            let res = {
                data: {
                    RetrieveConsent: {
                        consents: [],
                        profile: {},
                    },
                },
            };
            let consents = [];
            let profile = {};
            for (let item in subscriptions) {
                let consentsObj = {};
                // Non GCM Market
                if (Object.keys(subscriptions).length === 1 && Object.prototype.hasOwnProperty.call(subscriptions[item], 'isSubscribed')) {
                    const emailObj = subscriptions[item];
                    consentsObj.name = 'marketingEmail';
                    consentsObj.isChecked = emailObj?.isSubscribed;
                    //set a flag in session storage which is later on checked while calling update api
                    sessionStorage.setItem('isGcmMarket', false);
                    consents.push(consentsObj);
                }
                else {
                    // GCM Market
                    if (Object.prototype.hasOwnProperty.call(subscriptions[item], 'email')) {
                        const emailObj = subscriptions[item]?.email;
                        if (Object.prototype.hasOwnProperty.call(emailObj, 'isSubscribed')) {
                            consentsObj.name = item;
                            consentsObj.isChecked = emailObj?.isSubscribed
                            consents.push(consentsObj);
                        }
                    }
                }
            }
            profile.firstName = responseData?.profile?.firstName;
            profile.lastName = responseData?.profile?.lastName;
            profile.title = responseData?.data?.TITLE;
            res.data.RetrieveConsent = { consents, profile };
            return res;
        }
        case 'UPDATE': {
            const marketType = sessionStorage.getItem('isGcmMarket');
            let payloadObj = {
                "globalGSK": {}
            };
            let output = {};
            if (marketType && marketType === 'false') {
                // Non GCM Market
                obj.map((consentObj) => {
                    output.email = {
                        isSubscribed: consentObj?.isChecked
                    }
                    return output;
                });
            }
            else {
                // GCM Market
                obj.map((consentObj) => {
                    const property = consentObj?.name;
                    const newConsentObj = {
                        [property]: {
                            email: {
                                isSubscribed: consentObj?.isChecked
                            }
                        }
                    };
                    output = { ...output, ...newConsentObj }
                    return output;
                });
            }
            payloadObj.globalGSK = { ...output };
            if (Object.prototype.hasOwnProperty.call(payloadObj.globalGSK, 'unsubscribeAll')) {
                delete payloadObj.globalGSK['unsubscribeAll'];
            }
            return payloadObj;
        }
        default:
            break;
    }
};